import React, { useEffect, useState, useCallback } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import Select from "react-select";
import { DocumentDownload } from "iconsax-react";

function StockList({ activeTab }) {
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [stockData, setStockData] = useState([]);
  const [isReset, setIsReset] = useState(false);
  const [isFind, setIsFind] = useState(false);

  useEffect(() => {
    fetchPlantList();
    fetchProductList();
  }, []);

  const fetchPlantList = useCallback(() => {
    utils
      .callAPI("get", "/purchaseorder/plant/list")
      .then((res) => setPlantList(res?.result || []))
      .catch(() => setPlantList([]));
  }, []);

  const fetchProductList = useCallback(() => {
    utils
      .callAPI("get", "/Product/list")
      .then((res) => setProductList(res?.result || []))
      .catch(() => setProductList([]));
  }, []);

  const fetchStockData = () => {
    console.log(selectedProduct);
    utils
      .callAPI(
        "get",
        `/production/process/get-stock-list?page=${page}&per_page=${countPerPage}&product_id=${
          Object.keys(selectedProduct).length !== 0
            ? selectedProduct?.value
            : ""
        }&plant_id=${selectedPlant}`
      )
      .then((res) => {
        setStockData(res || []);
        setIsReset(false);
        setIsFind(false);
      })
      .catch(() => {
        setStockData([]);
        setIsReset(false);
        setIsFind(false);
      });
  };

  useEffect(() => {
    if (activeTab == "finishGoods") {
      fetchStockData();
    }
  }, [activeTab, page]);

  const columns = [
    { name: "Plant Location", selector: (row) => row.PlantLocation },
    { name: "Product Name", selector: (row) => row.ProductName },
    { name: "Product Code", selector: (row) => row.ProductCode },
    { name: "Available Quantity", selector: (row) => row.AvailableQuantity },
    {
      name: "Dispatch Quantity",
      selector: (row) => row.AssignedDispatchQuantity,
    },
    { name: "Total Quantity", selector: (row) => row.TotalQuantity },
  ];

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const options = productList?.map((prod) => ({
    value: prod.id,
    label: prod.productCode
      ? `${prod.product_name} (${prod.productCode})`
      : prod.product_name,
    productCode: prod.productCode,
  }));

  const handleProductSelection = (selected) => {
    setSelectedProduct(selected);
  };

  const handleSearch = () => {
    setIsFind(true);
  };

  const handleReset = () => {
    setSelectedPlant("");
    setSelectedProduct("");
    setIsReset(true);
  };

  useEffect(() => {
    if (isReset) {
      fetchStockData();
    }
  }, [isReset]);
  useEffect(() => {
    if (isFind) {
      fetchStockData();
    }
  }, [isFind]);

  const handleDownload = () => {
    utils
      .callAPI(
        "get",
        `/production/process/get-stock-list?page=${0}&per_page=${0}&product_id=${
          Object.keys(selectedProduct).length !== 0
            ? selectedProduct?.value
            : ""
        }&plant_id=${selectedPlant}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          const csvHeader =
            "Plant Name,Product Name,Product Code,Available Quantity,Dispatch Quantity,Total Quantity,";
          const csvRows = res?.result?.map((data, index) => {
            return `${data.PlantLocation},${data.ProductName},${data.ProductCode},${data.AvailableQuantity},${data.AssignedDispatchQuantity},${data.TotalQuantity}`;
          });

          const csvContent = [csvHeader, ...csvRows].join("\n");
          generateCSV(csvContent, "finish Goods.csv");
        } else {
        }
      })
      .catch((err) => {});
  };

  function generateCSV(filteredData, fileName) {
    const blob = new Blob([filteredData], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <RB.Row className="mb-2">
        <RB.Col md={4}>
          <RB.FloatingLabel
            controlId="plantLocation"
            label="Select Plant"
            className="floating-label-fancy"
          >
            <RB.Form.Select
              value={selectedPlant}
              onChange={(e) => setSelectedPlant(e.target.value)}
            >
              <option value="">All Plants</option>
              {plantList.map((plant) => (
                <option key={plant.id} value={plant.id}>
                  {plant.plant_name}
                </option>
              ))}
            </RB.Form.Select>
          </RB.FloatingLabel>
        </RB.Col>

        <RB.Col md={4}>
          <div className="mt-3">
            <RB.FloatingLabel
              controlId="productName"
              className="floating-label-fancy"
              // label="Product Name"
            >
              <Select
                options={options}
                value={selectedProduct}
                onChange={handleProductSelection}
                placeholder="Select Product Name"
                className="bom-productName-select"
                classNamePrefix="select"
                isClearable
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4} className="d-flex align-items-end">
          <div className="d-flex">
            <RB.Button
              variant="primary"
              className="me-2"
              onClick={handleSearch}
            >
              Search
            </RB.Button>
            <RB.Button variant="secondary" onClick={handleReset}>
              Reset
            </RB.Button>
          </div>

          <div className="ms-auto">
            <RB.Button
              size="sm"
              variant="primary"
              className="btn-circle"
              onClick={handleDownload}
              disabled={stockData?.result?.length == 0}
            >
              <DocumentDownload />
            </RB.Button>
          </div>
        </RB.Col>
      </RB.Row>

      <DataTable
        columns={columns}
        data={stockData?.result}
        highlightOnHover
        responsive
        pagination
        paginationServer
        paginationTotalRows={stockData.total}
        paginationPerPage={countPerPage}
        paginationComponentOptions={{
          noRowsPerPage: true,
        }}
        paginationComponent={() => (
          <CustomPagination
            currentPage={page}
            totalRows={stockData.total}
            rowsPerPage={countPerPage}
            onPageChange={handlePageChange}
          />
        )}
        // striped
        onChangePage={(page) => setPage(page)}
        persistTableHead
        customStyles={{
          head: {
            style: {
              fontSize: "0.875rem",
              fontWeight: "bold",
            },
          },
        }}
      />
    </>
  );
}

export default StockList;
